import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

const API_URL = process.env.API_URL

export default {
  query (params) {
    return Vue.http.get(`${API_URL}expenses`, {params: params})
  },
  get (id) {
    return Vue.http.get(`${API_URL}expenses/${id}`)
  },
  create (data) {
    return Vue.http.post(`${API_URL}expenses`, data)
  },
  update (id, data) {
    return Vue.http.patch(`${API_URL}expenses/${id}`, data)
  },
  duplicate (id) {
    return Vue.http.post(`${API_URL}expenses/${id}/replicate`)
  },
  delete (id) {
    return Vue.http.delete(`${API_URL}expenses/${id}`)
  },
  deleteFile (id, fileId) {
    return Vue.http.delete(`${API_URL}expenses/${id}/file/${fileId}`)
  },
  approveBatch (ids) {
    return Vue.http.patch(`${API_URL}expenses/approval`, { ids })
  },
  updatePayment (id, data) {
    return Vue.http.patch(`${API_URL}expenses/${id}/payment`, data)
  },
  deletePaymentFile (id, fileId) {
    return Vue.http.delete(`${API_URL}expenses/${id}/payment/file/${fileId}`)
  },
  statusLabel: {
    provision: 'Provisão',
    waiting: 'Aguardando',
    approved: 'Aprovado',
    rejected: 'Rejeitado'
  },
  statusClass: {
    provision: 'is-purple',
    waiting: 'is-warning',
    approved: 'is-success',
    rejected: 'is-danger'
  }
}



// WEBPACK FOOTER //
// ./src/services/expense.js